import React from 'react';

const ContactSection = props => (
  <section>
    <div className="container">
      <div className="row">
        <div className="col-lg-6 mx-auto text-center">
          <h2 className="h1">{props.contact.title}</h2>
          <div className="u-h-4 u-w-50 bg-primary rounded mt-4 u-mb-40 mx-auto" />
          <p>{props.contact.forma.desc}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center mt-5">
          <form action="https://formspree.io/info@vespaklubrijeka.com" method="POST">
            <input type="hidden" name="_next" value="https://www.vespaklubrijeka.com" />
            <input type="hidden" name="_subject" value="📧 📧 📧 - Vespaklubrijeka.com - Nova poruka sa site-a" />
            <div className="row">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control u-rounded-50 p-3 u-mb-30"
                  name={props.contact.forma.formName}
                  placeholder={props.contact.forma.formName}
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control u-rounded-50 p-3 u-mb-30"
                  name={props.contact.forma.formEmail}
                  placeholder={props.contact.forma.formEmail}
                  required
                />
              </div>
            </div>
            <textarea
              className="form-control u-rounded-15 p-3 u-mb-30"
              rows="6"
              name={props.contact.forma.formMessage}
              placeholder={props.contact.forma.formMessage}
              required
            />
            <button className="btn btn-rounded btn-primary" type="submit">
              {props.contact.forma.formCta}
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
);

export default ContactSection;



// WEBPACK FOOTER //
// ./src/components/ContactSection.js